import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import ProfileSection from './ProfileSection/ProfileSection';


const ProfileSectionPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.profilePage.name]: (
      <ProfileSection relationship={resource?.relationship(fr.relationships.profilePage.name)} />
    ),
  }, null);
};

ProfileSectionPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
ProfileSectionPicker.defaultProps = {};

export default ProfileSectionPicker;
